import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type OptionPriceSingleCurrencyClasses =
  | 'accessoryPriceContent'
  | 'accessoryPriceLabel'
  | 'accessoryPriceSecondaryLabel'
  | 'accessoryPriceContainer';

const optionPriceSingleCurrencyStyles = makeStyles<ISpcTheme, OptionPriceSingleCurrencyClasses>(
  theme => ({
    accessoryPriceContainer: {
      lineHeight: 1,
    },
    accessoryPriceContent: {
      display: 'inline',
      fontSize: theme.typography.fontSM,
      fontFamily: theme.typography.fontFamily2,
      '& span': {
        display: 'inline-block',
      },
    },
    accessoryPriceLabel: {
      display: 'inline-flex',
      paddingRight: 4,
      marginLeft: 2,
    },
    accessoryPriceSecondaryLabel: {
      marginLeft: '4px',
    },
  }),
  { name: 'Customise_OptionPriceSingleCurrency' },
);

export default optionPriceSingleCurrencyStyles;
